export default __webpack_public_path__ + "fe4cf33be8c66b7f3edc76220257c9e1.svg";